import { getLastSoftInfo } from "../service/register";

const softForm = {
  name: "softForm",
  state: {}, // initial state
  reducers: {
    setLastSoftInfo(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    clearInfo() {
      return {};
    },
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async setLastSoftInfoAsync({ id }) {
      const info = await getLastSoftInfo({ id });
      this.setLastSoftInfo(info);
      return info
    },
  }),
};

export default softForm;
